import React, { Component } from 'react'
import { capitalize } from 'humanize-plus'
import withNotifications from 'components/shared/notifications'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { Div, ToolTip } from '@driftt/tide-core-legacy'
import Bolt from './Icons/Bolt'
import './style.styl'

const classesByScore = Object.freeze({
  '1': 'cql-option cql-low',
  '2': 'cql-option cql-med',
  '3': 'cql-option cql-high',
})

const ICONS_FOR_SCORE = {
  '1': (
    <Div className="cql-option--icon-wrapper">
      <Bolt className="lightning-bolt" height={15} />
    </Div>
  ),
  '2': (
    <Div className="cql-option--icon-wrapper">
      <Bolt className="lightning-bolt" height={15} />
      <Bolt className="lightning-bolt" height={15} />
    </Div>
  ),
  '3': (
    <Div className="cql-option--icon-wrapper">
      <Bolt className="lightning-bolt" height={15} />
      <Bolt className="lightning-bolt" height={15} />
      <Bolt className="lightning-bolt" height={15} />
    </Div>
  ),
}

class MinimumCqlScoreWidget extends Component {
  static propTypes = {
    integrationName: PropTypes.string.isRequired,
    setMinimumCQLScore: PropTypes.func.isRequired,
    getMinimumCQLScore: PropTypes.func.isRequired
  }
  state = {
    score: undefined
  }
  getScore(data) {
    // score can come from the field 'score' or 'minimumCQLScore'
    // depending on the endpoint being hit
    let score = data.score
    if (!score) {
      score = data.minimumCQLScore
    }
    return score
  }

  setCQLScore = score => {
    const { integrationName, notifications, setMinimumCQLScore } = this.props
    setMinimumCQLScore({ integrationName, score })

    this.setState({
      score: score,
    })
    notifications.success(`${capitalize(integrationName)} settings are updated!`)
  }

  renderCQLIcon = score => {
    const cqlScore = this.state.score

    const className = classnames(classesByScore[score], {
      'cql--selected': cqlScore === score,
    })

    let tooltipText = `CQL score: ${score}`

    return (
      <ToolTip hover={true} component={tooltipText} flow="up" className={'cql-option--tooltip'}>
        <Div className={className} onClick={() => this.setCQLScore(score)}>
          {ICONS_FOR_SCORE[score]}
        </Div>
      </ToolTip>
    )
  }

  componentDidMount() {
    const { integrationName, getMinimumCQLScore } = this.props
    getMinimumCQLScore(integrationName).then(data => {
      const score = this.getScore(data)
      this.setState({ score })
    })
  }

  render() {
    return (
      <Div>
        <Div className="integrations--mark-cql">
          {this.renderCQLIcon(1)}
          {this.renderCQLIcon(2)}
          {this.renderCQLIcon(3)}
        </Div>
      </Div>
    )
  }
}

export default withNotifications(MinimumCqlScoreWidget)



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/pages/MinimumCqlScoreWidget/index.js